import "./App.css";
import { Routes, BrowserRouter, Route } from "react-router-dom";

import React, { useState } from "react";
import { MainStore } from "./utils/store/context";

import { ConfigProvider, Layout } from "antd";
import Header from "./components/header";
import Footer from "./components/footer";
import Home from "./pages/home";
import Products from "./pages/products";
import Quotation from "./pages/quotation";
import AboutUs from "./pages/about-us";
import ContactUs from "./pages/contact-us";
import Catalog from "./pages/catalog";
import Tags from "./pages/categories/tags";
import Categories from "./pages/categories";
const { Content } = Layout;

function App() {
  const [cart, setCart] = useState(
    localStorage.getItem("cart")
      ? JSON.parse(localStorage.getItem("cart")).length
      : 0
  );

  return (
    <ConfigProvider
      theme={{
        token: {
          borderRadius: 10,
          colorPrimary: "#C63D8F",
          colorText: "#3A3A3A",
        },
        components: {
          Switch: {
            trackHeightSM: 30,
            trackHeight: 30,
            handleSize: 30,
          },
        },
      }}
    >
      <MainStore.Provider value={{ cart, setCart }}>
        <BrowserRouter>
          <Layout>
            <Content>
              <div style={{ padding: 20, backgroundColor: "white" }}>
                <Header />
                <div className="main-container">
                  <Routes>
                    <Route exact path="/" element={<Home />} />
                    <Route exact path="/products" element={<Categories />} />
                    <Route
                      exact
                      path="/products/:category_id"
                      element={<Tags />}
                    />
                    <Route
                      exact
                      path="/products/:category_id/:tag_id/:product_id"
                      element={<Products />}
                    />
                    <Route exact path="/quotation" element={<Quotation />} />
                    <Route exact path="/catalog" element={<Catalog />} />
                    <Route exact path="/about-us" element={<AboutUs />} />
                    <Route exact path="/contact-us" element={<ContactUs />} />
                  </Routes>
                </div>
                <Footer />
              </div>
            </Content>
          </Layout>
        </BrowserRouter>
      </MainStore.Provider>
    </ConfigProvider>
  );
}

export default App;
